// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var setText = $foreign.setTextImpl;
var setAttributes = function (node) {
    return function (attrs) {
        return function () {
            return $foreign["_setAttributes"](node, attrs);
        };
    };
};
var removeAttributes = $foreign.removeAttributesImpl;
var removeAllBetween = $foreign.removeAllBetweenImpl;
var parentNode = $foreign.parentNodeImpl(Data_Maybe.Just.create)(Data_Maybe.Nothing.value);
var moveAllBetweenInclusive = $foreign.moveAllBetweenInclusiveImpl;
var insertBefore = $foreign.insertBeforeImpl;
var createTextNode = $foreign.createTextNodeImpl;
var createElementNS = function (v) {
    if (v instanceof Data_Maybe.Just) {
        return $foreign.createElementNSImpl(v.value0);
    };
    if (v instanceof Data_Maybe.Nothing) {
        return $foreign.createElementImpl;
    };
    throw new Error("Failed pattern match at Specular.Dom.Browser (line 44, column 1 - line 44, column 61): " + [ v.constructor.name ]);
};
var createElement = createElementNS(Data_Maybe.Nothing.value);
var createDocumentFragment = $foreign.createDocumentFragmentImpl;
var appendRawHtml = $foreign.appendRawHtmlImpl;
var appendChild = $foreign.appendChildImpl;
var addEventListener = $foreign.addEventListenerImpl;
module.exports = {
    addEventListener: addEventListener,
    createTextNode: createTextNode,
    setText: setText,
    createDocumentFragment: createDocumentFragment,
    createElementNS: createElementNS,
    createElement: createElement,
    setAttributes: setAttributes,
    removeAttributes: removeAttributes,
    parentNode: parentNode,
    insertBefore: insertBefore,
    appendChild: appendChild,
    appendRawHtml: appendRawHtml,
    removeAllBetween: removeAllBetween,
    moveAllBetweenInclusive: moveAllBetweenInclusive,
    removeNode: $foreign.removeNode,
    createTextNodeImpl: $foreign.createTextNodeImpl,
    setTextImpl: $foreign.setTextImpl,
    createDocumentFragmentImpl: $foreign.createDocumentFragmentImpl,
    createElementNSImpl: $foreign.createElementNSImpl,
    createElementImpl: $foreign.createElementImpl,
    "_setAttributes": $foreign["_setAttributes"],
    removeAttributesImpl: $foreign.removeAttributesImpl,
    parentNodeImpl: $foreign.parentNodeImpl,
    insertBeforeImpl: $foreign.insertBeforeImpl,
    appendChildImpl: $foreign.appendChildImpl,
    removeAllBetweenImpl: $foreign.removeAllBetweenImpl,
    appendRawHtmlImpl: $foreign.appendRawHtmlImpl,
    moveAllBetweenInclusiveImpl: $foreign.moveAllBetweenInclusiveImpl,
    addEventListenerImpl: $foreign.addEventListenerImpl,
    preventDefault: $foreign.preventDefault,
    innerHTML: $foreign.innerHTML
};
//# sourceMappingURL=index.js.map
